var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ListPage',{attrs:{"gridData":_vm.data,"gridConfig":_vm.gridConfig,"filters":_vm.filters}})}
var staticRenderFns = []

export { render, staticRenderFns }